export enum ReactEventType {
  RIGHT_CLICK = 'contextmenu',
  LEFT_CLICK = 'click',
}

export enum CorrosionRateUnit {
  INCH_PER_YEAR = 'in/yr',
  PERCENT_CURRENT_CORROSION = '%',
}

export const DATE_FORMAT = 'YYYY-MM-DD'
export const YEAR_FORMAT = 'YYYY'
export const INSPECTION_SLUG_DATE_FORMAT = 'YYYYMMDD'
// TODO: Make enum for units, convert to abbreviations
export const REPAIR_AREA_UNIT = 'sq ft'
export const CORROSION_LINER_DEFAULT_COST_SQFT = 100
export const AHP_ACTION_CREATION_SOURCE_CDF_SLUG = 'custom_cdf_rl_scenario'
